import { ButtonLink } from '@zoopla-eng/zds-components/button';
import { FC } from 'react';
import { trackSegmentAndGAEvent } from '@zoopla/tracking';
import { NextRouter, useRouter } from 'next/router';
import { isExternalUri } from '../../../functions/helpers';

interface CmsEventTracking {
    segmentEventName: string;
    eventAction: string;
    eventCategory: string;
    eventLabel?: string;
}

export interface CmsEventFields {
    fields: CmsEventTracking;
}

interface ButtonNode {
    buttonUrl: string;
    category: 'primary' | 'secondary' | 'tertiary';
    buttonLabel: string;
    eventTracking?: CmsEventFields;
}

function doTracking(data: CmsEventTracking, pageSlug: string) {
    const GAData = {
        eventAction: data.eventAction,
        eventCategory: data.eventCategory,
        eventLabel: data.eventLabel ?? undefined
    };
    return trackSegmentAndGAEvent(
        data.segmentEventName,
        GAData,
        `${pageSlug}/`
    );
}

const ButtonEntry: FC<ButtonNode> = ({
    buttonUrl,
    category,
    buttonLabel,
    eventTracking = undefined
}) => {
    const router: NextRouter = useRouter();
    const trackClick = eventTracking
        ? () => doTracking(eventTracking.fields, router.pathname)
        : undefined;

    return (
        <ButtonLink
            href={buttonUrl}
            category={category}
            title={buttonLabel}
            aria-label={buttonLabel}
            onClick={trackClick}
            target={isExternalUri(buttonUrl) ? '_blank' : undefined}
        >
            {buttonLabel}
        </ButtonLink>
    );
};

export default ButtonEntry;
